module.exports = __webpack_public_path__ + "bg.3MbFjnlm.svg";